
import api from './api'
import { useDownload } from '@/helpers/download'

export default {
    
    count(params = {}) {

        return api.get('/commandes', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    get(id) {

        return api.get('/commandes/' + id, { cache: false })
            .then( json => json.data )
    },

    getDocuments(id, ligneNums) {

        return new Promise((resolve, reject) => {

            api.post('/commandes/' + id + '/documents/file', { lignes: ligneNums })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        })            
    },

    getFile(id) {
        
        return new Promise((resolve, reject) => {

            api.post('/commandes/' + id + '/file', {})
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
            })

    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/commandes/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },    

    list(params = {}) {

        return api.get('/commandes', { params })
            .then( json => json.data )
            
    },

    retrieve(id) {

        return api.get('/commandes/' + id + '/retrieve', { cache: false })
            .then( json => {
                let commande = json.data
                return commande 
            })
            
    },     

    search(params = {}) {

        return api.get('/commandes', { params })
            .then( json => json.data )            
    } 
}
